module.exports = __webpack_public_path__ + "static/hca-logo-85425a1c21cb30dc1b81eb21cb6e7844.jpg";